import * as React from 'react';
import { colors } from '../../../index';

const IconCircleNine = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 21 22",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .046)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    opacity: 0.147,
    fill: "#FCFCFC",
    cx: 10.5,
    cy: 10.5,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.56 11.078a2.208 2.208 0 01-.675.541 1.833 1.833 0 01-.86.205c-.41 0-.767-.1-1.071-.302a1.966 1.966 0 01-.705-.851A2.902 2.902 0 018 9.458c0-.474.09-.902.27-1.282.181-.38.437-.672.769-.874A2.19 2.19 0 0110.199 7c.703 0 1.257.263 1.662.788s.607 1.241.607 2.149v.263c0 1.382-.273 2.39-.82 3.027-.546.635-1.37.961-2.472.978H9v-.761h.19c.745-.013 1.317-.208 1.717-.583.4-.376.618-.97.654-1.783zm-1.39 0c.303 0 .582-.093.837-.278.256-.185.442-.415.559-.688v-.36c0-.593-.129-1.074-.386-1.445-.256-.37-.582-.556-.975-.556-.397 0-.716.152-.956.456-.24.304-.361.705-.361 1.203 0 .484.116.883.349 1.197.232.314.543.47.934.47z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};

export default IconCircleNine;